import { render, staticRenderFns } from "./NotificationForm.vue?vue&type=template&id=0e8d6708&scoped=true"
import script from "./NotificationForm.vue?vue&type=script&lang=js"
export * from "./NotificationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8d6708",
  null
  
)

export default component.exports